import React from 'react';
import { useRecoilState } from 'recoil';
import { Box, Divider, IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { isVisibleMorphingBoxState } from 'features/three-view/state/threeAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { MorphingBoxForm } from './MorphingBoxForm';
import { TargetControlPointsForm } from './TargetControlPointsForm';
import { MorphingParametersForm } from './MorphingParametersForm';
import { ParameterManager } from './ParameterManager';

const subtitleContainerSx = {
  position: 'sticky', // Make the entire container sticky
  top: 0, // Stick to the top
  zIndex: 10, // Ensure it appears above other content
  width: '100%',
  backgroundColor: '#1e1e1e'
};

const iconSx = {
  fontSize: 12,
  color: '#e1e1e1'
};

export const MorphingPanel: React.FC = () => {
  const [isVisibleMorphingBox, setisVisibleMorphingBox] = useRecoilState(isVisibleMorphingBoxState);

  const handleToggle = () => {
    setisVisibleMorphingBox((prev) => !prev);
  };

  return (
    <Box component="div" sx={{ height: '100%', width: '100%' }}>

      {/* Sticky container for subtitle and divider */}
      <Box component="div" sx={subtitleContainerSx}>
        <Box component="div" sx={{ display: 'flex', alignItems: 'center', height: '5%' }}>
          <CustomTypography >FFD Setup</CustomTypography>
          <IconButton onClick={handleToggle}>
            {isVisibleMorphingBox ? <VisibilityIcon sx={iconSx} /> : <VisibilityOffIcon sx={iconSx} />}
          </IconButton>
        </Box>

        <Divider sx={{ my: 0.5, bgcolor: '#e1e1e1' }} />

        <ParameterManager />
      </Box>

      {/* Scrollable content below */}
      <Box component="div" sx={{ width: '100%', paddingBottom: 0.5 }}>
        <MorphingBoxForm subtitle={"Morphing Box"} />
      </Box>
      <Box component="div" sx={{ width: '100%', paddingBottom: 0.5 }}>
        <TargetControlPointsForm subtitle={"Target Control Points"} />
      </Box>
      <Box component="div" sx={{ width: '100%' }}>
        <MorphingParametersForm subtitle={"Morphing Parameters"} />
      </Box>

    </Box>
  );
};
